import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperSlides = () => {
  new Swiper('.swiper-how', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1.6,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
  });
  new Swiper('.swiper-features', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1.6,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
  });
  new Swiper('.swiper-reviews', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        centeredSlides: 1,
      },
      1440: {
        slidesPerView: 5,
        spaceBetween: 10,
        centeredSlides: 0,
      },
    },
  });
};
export default swiperSlides;
